
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/slack-alternative",
      function () {
        return require("private-next-pages/slack-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/slack-alternative"])
      });
    }
  